import EditEventModal from './EditEventModal.container'

export default EditEventModal
